import type { ReactElement } from 'react'
import styled from 'styled-components'

import { BlogList } from './BlogList'
import { PickUpArticle } from './PickUpArticle'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'

import type { Blog, BlogTag } from '@/types/blog'

type Props = {
  blogList: readonly Blog[]
  tagList: readonly BlogTag[]
}

export const BlogPage = ({ blogList, tagList }: Props) => {
  const pickUpArticle = blogList.find(({ isPickUp }) => isPickUp)

  return (
    <Wapper>
      <SectionTitle
        titleText="TRIAL Blog"
        subTitleText="広報ブログ"
        color="normal"
      />
      <Spacer h={{ sp: 50, pc: 73 }} />
      {pickUpArticle && (
        <>
          <PickUpArticle {...pickUpArticle} />
          <Spacer h={{ sp: 24, pc: 60 }} />
        </>
      )}
      <BlogList blogList={blogList} tagList={tagList} />
    </Wapper>
  )
}

BlogPage.getLayout = function getLayout(page: ReactElement) {
  const pageTitle = {
    title: 'NEWS ROOM',
    subTitle: 'ニュースルーム',
  }

  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: 'ニュースルーム', path: '/news/' },
    { name: '広報ブログ', path: '' },
  ]

  return (
    <>
      <Head
        title="広報ブログ"
        description="トライアルホールディングスの広報部がお届けするブログです。"
        ogp={{ url: 'news/blog/' }}
      />
      <TitleLayout {...pageTitle} breadCrumbs={breadCrumbs}>
        {page}
      </TitleLayout>
    </>
  )
}

const Wapper = styled.div`
  width: 1040px;
  margin: 0 auto;
  padding: 70px 0 130px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 36px 0 80px;
  }
`
